import { all, takeLatest } from "redux-saga/effects";
import { NAVIGATE } from "../reducers/actionTypes";
import NavigationService from "../utils/NavigationService";

function navigateto(action) {
  const { params } = action;
  NavigationService.navigate(...params);
}

export default function* () {
  yield all([takeLatest(NAVIGATE, navigateto)]);
}
